<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        List of Recurring Invoices
        <div class="card-header-actions mt-0 mb-0">
          <b-button variant="success mr-1" @click="generateInvoices">Generate Due Invoices</b-button>
          <b-button variant="primary mr-1" @click="add">Add New Schedule</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="secondary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>

      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input v-model="tblData.customer" placeholder="Search Customer"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="tblData.description" placeholder="Search Description"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Next Generate</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="width: 18% !important"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="width: 18% !important"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Status</label></b-input-group-prepend>
            <b-form-select v-model="tblData.is_active" :options="[{text: 'All', value: ''}, {text: 'Active', value: true}, {text: 'Inactive', value: false}]"></b-form-select>
            <b-input-group-append>
              <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        @row-clicked="rowClicked"
      >
        <!-- <template v-slot:cell(template_invoice)="data">
          <b-link @click.stop="viewTemplate(data.item.arinvkey)">{{ data.item.invoiceno }}</b-link>
        </template> -->

        <template v-slot:cell(frequency)="data">
          Every {{ data.item.frequency }} {{ data.item.frequency_unit }}
        </template>
        <template v-slot:cell(start_date)="data">
          {{ data.item.start_date | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(end_date)="data">
          {{ data.item.end_date | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(next_generation_date)="data">
          {{ data.item.next_generation_date | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(ttlgross)="data">
          {{ data.item.ttlgross | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(ttldiskon)="data">
          {{ data.item.ttldiskon | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(ttlnetto)="data">
          {{ data.item.ttlnetto | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(ttlvat)="data">
          {{ data.item.ttlvat | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(ttlamtdue)="data">
          {{ data.item.ttlamtdue | numFormat("0,0.00") }}
        </template>

        <template v-slot:cell(is_active)="data">
          <b-badge :variant="data.item.is_active ? 'success' : 'danger'">
            {{ data.item.is_active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>

        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm">
            <template v-slot:button-content>
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)">Edit Schedule</b-dropdown-item>
            <b-dropdown-item @click="rowToggleStatus(data.item)">
              {{ data.item.is_active ? 'Deactivate' : 'Activate' }}
            </b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" class="text-danger">Delete</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <b-row class="mt-2">
        <b-col>
          <b-pagination
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
            align="right"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="showGenModal" title="Generate Recurring Invoices" @ok="doGenerate" ok-title="Generate" ok-variant="success">
      <div class="p-3">
        <p>Generate all active invoices that are due up to the selected date:</p>
        <b-input-group>
          <b-input-group-prepend><label class="text-right mr-1" style="width: 90px; padding-top: 7px;">Due Up To</label></b-input-group-prepend>
          <b-form-input type="date" v-model="genDate"></b-form-input>
          <b-input-group-prepend><span class="input-group-text">{{genDate | moment("dddd") }}</span></b-input-group-prepend>
        </b-input-group>
      </div>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import api from "../../apis/recurringinvoice";

export default {
  components: { Loading },
  data() {
    return {
      isLoading: false,
      showFilter: false,
      showGenModal: false,
      genDate: "",
      data: [],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: "invdate",
        sortDesc: true,
        customer: "",
        tgl1: "",
        tgl2: ""
      },
      tblFields: [
        { key: "CustCode", label: "Customer Code" },
        { key: "CustName", label: "Customer Name" },
        { key: "description", label: "Description" },
        { key: "frequency", label: "Frequency" },
        { key: "start_date", label: "Start Date" },
        { key: "end_date", label: "End Date" },
        { key: "next_generation_date", label: "Next Date" },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "ttlamtdue",
          label: "Invoice Amount",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        { key: "is_active", label: "Status" },
        { key: "action", label: "Action" }
      ]
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.isLoading = true;
      api.list(this.tblData).then(res => {
        this.data = res;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.$bvToast.toast(err.message || 'Error loading data', { variant: 'danger' });
      });
    },
    generateInvoices() {
      this.genDate = new Date().toISOString().split('T')[0];
      this.showGenModal = true;
    },
    doGenerate(bvModalEvt) {
      if (!this.genDate) {
        bvModalEvt.preventDefault();
        this.$bvToast.toast('Please select a "Due Up To" date', { variant: 'warning' });
        return;
      }
      this.isLoading = true;
      api.generate({ tgl2: this.genDate }).then(res => {
        this.isLoading = false;
        this.$bvToast.toast(res.data.message || 'Invoices generated successfully', { variant: 'success' });
        this.refresh();
      }).catch(err => {
        this.isLoading = false;
        this.$bvToast.toast(err.message || 'Error generating invoices', { variant: 'danger' });
      });
    },
    add() {
      this.$router.push({ name: "receivable.arinvrecurringfrm" });
    },
    rowEdit(item) {
      this.$router.push({ name: "receivable.arinvrecurringfrm", query: { id: item.recinvkey } });
    },
    viewTemplate(arinvkey) {
      this.$router.push({ name: "receivable.arinvview", query: { key: arinvkey } });
    },
    rowToggleStatus(item) {
      this.isLoading = true;
      api.toggleStatus(item.recinvkey, !item.is_active).then(() => {
        this.refresh();
      }).catch(err => {
        this.isLoading = false;
        this.$bvToast.toast(err.message || 'Error updating status', { variant: 'danger' });
      });
    },
    rowDel(item) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this schedule?', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.isLoading = true;
          api.delete(item.recinvkey).then(() => {
            this.refresh();
          }).catch(err => {
            this.isLoading = false;
            this.$bvToast.toast(err.message || 'Error deleting data', { variant: 'danger' });
          });
        }
      });
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    close() {
      this.$router.push({ name: "receivable.home" });
    },
    search() {
      this.refresh();
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.description = "";
      this.tblData.is_active = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.refresh();
    }
  }
};
</script>
